module.exports = __webpack_public_path__ + "img/show-card-img.eee7919f.svg";